// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Form from '@cloudscape-design/components/form';
import FormField from '@cloudscape-design/components/form-field';
import Header from '@cloudscape-design/components/header';
import Input, { InputProps } from '@cloudscape-design/components/input';
import parse from 'html-react-parser';
import Cookies from "js-cookie";
import React, { useEffect, useRef, useState } from 'react';
const _preserve = React.version;


import { Box, ContentLayout, Grid } from '@cloudscape-design/components';
import Flashbar, { FlashbarProps } from '@cloudscape-design/components/flashbar';
import SpaceBetween from '@cloudscape-design/components/space-between';

import { mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js';
import Icon from '@mdi/react';
import PhoneInput from '../../../../components/PhoneInput';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import {
  clearNotifications,
  getCookie,
  getParameter,
  getUrlVersion,
  isMobileDevice,
  isValidPhone,
  setData,
  setDisplayName,
  setIdUser,
  setLoading,
  setMenu,
  setPhone,
  setVersion
} from '../../../commons/functions'; // Import the function
import { useGlobalState } from '../../../context/GlobalStateContext';
import { useRouter } from '../../router';


export const UserLoginPage = () => {
  const { idUser, data, menu, phone, loading } = useGlobalState();
  React.version;
  const { navigate } = useRouter();
  const movilRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const [inputPassword, setInputPassword] = useState(''); //Arl3quin$$
  const [passWordType, setPassWordType] = useState('password');
  const [errorLogin, setErrorLogin] = useState<any>([]);
  const [messagesModal, setMessagesModal] = useState<FlashbarProps.MessageDefinition[]>([]);
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    if (getCookie("JWT") !== "" && idUser && idUser > 0) {
      fetch(`${getUrlVersion()}/routing/v1/?redirect2`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/login/data',
          'JWT': getCookie("JWT"),
        },
        body: JSON.stringify({ masters: [] }),
      }).then(async (response) => {
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
        const data2 = await response.json();
        if (data2.code === 0) {

          if (data2.menu && data2.menu != menu) {
            setMenu(data2.menu)
          }
          if (data2.masters) {
            //localStorage.setItem("data", JSON.stringify(data2.masters))
            setData(saveMasters(data2.masters, data))

          }

          fetch(`${getUrlVersion()}/routing/v1/?redirect3C`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-routing': '/private/user/login/data',
              'JWT': getCookie("JWT"),
            },
            body: JSON.stringify({ mastersDetail: true }),
          }).then(async (response) => {
            if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
            const data2 = await response.json();
            if (data2.code === 0) {
              if (data2.masters) {
                //localStorage.setItem("data", JSON.stringify(data2.masters))
                setData(saveMasters(data2.masters, data))
              }
            }
          }).catch(err => console.error("Background fetch error", err));

        }
      }).catch(err => console.error("Background fetch error", err));
    }
  }, [shouldRedirect]); //, JWT, idUser

  const handleInit = async () => {
    try {

      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/login/data',
          'JWT': getCookie("JWT"),
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const dataTmp = await response.json();
      if (dataTmp.serverVersion) {
        setVersion(dataTmp.serverVersion)
      }
      else {
        setVersion("0.0.0")
      }
    } catch (error: any) {
      console.error(error);
    } finally {
    }
  };
  useEffect(() => {
    handleInit();
  }, []);

  const handleGetMasters = async () => {
    try {
      setLoading(true)
      const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/login/data',
          'JWT': getCookie("JWT"),
        },
        body: JSON.stringify({ masters: [] }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data2 = await response.json();
      if (data2.code == 0) {
        if (data2.masters) {
          //localStorage.setItem("data", JSON.stringify(data2.masters))
          setData(saveMasters(data2.masters, data))
        }

        const rUrl = getParameter(window.location.hash, "returnUrl") || 'home';
        setTimeout(() => {
          navigate(rUrl);
        }, 50);

      } else {

        setMessagesModal([{ type: 'error', content: parse(data2.status), id: 'server-success' }]);
      }
    } catch (error: any) {
      setMessagesModal([{ type: 'error', content: `Error de red y/o comunicaciones2: ${error.message}`, id: 'server-success' }]);
    } finally {
      setLoading(false)
    }
  }

  const handleValidatePasword = async () => {
    setErrorLogin([]);
    try {
      clearNotifications(setData);
      setLoading(true)
      const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/public/login/step2',
          // 
        },
        body: JSON.stringify({
          phone: phone,
          password: inputPassword,
        }),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        setIdUser(dataWeb.idUser);
        setPhone(dataWeb.phone);
        setDisplayName(dataWeb.displayName);

        Cookies.set("JWT", dataWeb.JWT, {
          expires: 7, // cookie expiration in days
          path: "/",     // available on all paths
          sameSite: "strict"
        });
        clearNotifications(setData);

        if (!data.users) {
          handleGetMasters()
        } else {
          const rUrl = getParameter(window.location.hash, "returnUrl") || 'home';
          setShouldRedirect(true);
          //console.log("Redirecting to:", rUrl);
          setTimeout(() => {
            navigate(rUrl);
          }, 50);
        }
        //navigate(rUrl)
        //window.location.hash = "#home";//rUrl

      } else {
        setErrorLogin([{ type: 'error', content: dataWeb.status, id: 'server-success', onDismiss: () => setErrorLogin([]) }]);
      }
    } catch (error: any) {
      setErrorLogin([{ type: 'error', content: `Error de red y/o comunicaciones: ${error.message}`, id: 'server-error', onDismiss: () => setErrorLogin([]) }]);
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (isValidPhone(phone.toString())) {
      passwordRef.current?.focus();
    } else {
      movilRef.current?.focus();
    }

  }, [])
  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      backgroundImage: `url("resources/portal.${isMobileDevice() ? "M" : "D"}.jpg")`,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: 0,
      padding: 0,
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    }}>
      <Form><div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
      }}>
        <div style={{
        }}>
          <ContentLayout
            defaultPadding
            disableOverlap
            headerBackgroundStyle={mode =>
              `transparent`
            }
            header={
              <Box padding={{ vertical: "xxxl" }}>
                <Grid
                  gridDefinition={[
                    { colspan: { default: 12, s: 8 } }
                  ]}
                >
                  <Container>
                    <Box padding="s">
                      <Box
                        fontSize="display-l"
                        fontWeight="bold"
                        variant="h1"
                        padding="n"
                      >
                        CPV
                      </Box>
                      <Box
                        fontSize="display-l"
                        fontWeight="light"
                      >
                        IntraNET Socios
                      </Box>
                      <Box
                        variant="p"
                        color="text-body-secondary"
                        margin={{ top: "xs", bottom: "l" }}
                      >
                        Club de Planeadores de Vitacura
                      </Box>
                      <div style={{ width: "100%", alignItems: "center", display: "flex", justifyContent: "center" }}>
                        <div style={{ minWidth: "300px", maxWidth: '400px' }}>
                          <Container>
                            <Form header={<Header variant='h3'>Iniciar sesión</Header>}
                              actions={
                                <Button onClick={handleValidatePasword} variant="primary"
                                  disabled={(phone.length < 8 || !isValidPhone(phone)) || inputPassword.length < 4}
                                  loading={loading}
                                >Validar</Button>
                              }
                              secondaryActions={
                                <Button variant="inline-link" onClick={() => {
                                  window.location.hash = '#user/restore';
                                }}>Restaurar</Button>
                              }
                            >
                              <Flashbar items={errorLogin} />
                              <SpaceBetween size="l">
                                <FormField
                                  label="Teléfono"
                                  constraintText="Teléfono primario registrado en CPV">
                                  <PhoneInput value={phone.toString()}

                                    disabled={loading}
                                    fullWidth={true}
                                    onChange={(phone) => {
                                      setPhone(phone)
                                    }}
                                    ref={movilRef}

                                  />
                                </FormField>
                                <FormField label="Contraseña"
                                  info={
                                    inputPassword.length > 0 && (

                                      <div
                                        onMouseDown={() => { setPassWordType("text") }}
                                        onMouseUp={() => { setPassWordType("password") }}
                                        onMouseLeave={() => { setPassWordType("password") }}

                                        onTouchStart={(e) => {
                                          console.log("onTouchStart")
                                          e.preventDefault();
                                          setPassWordType("text");
                                        }}
                                        onTouchEnd={() => {
                                          console.log("onTouchEnd")
                                          setPassWordType("password")
                                        }}
                                        onTouchCancel={() => {
                                          console.log("onTouchCancel")
                                          setPassWordType("password")
                                        }}
                                      >
                                        {
                                          passWordType === "text" ? <Icon path={mdiEyeOutline} size={0.75} /> : <Icon path={mdiEyeOffOutline} size={0.75} />
                                        }</div>
                                    )}>
                                  <Input
                                    disabled={loading}
                                    ref={passwordRef}
                                    controlId='infoPassword'
                                    value={inputPassword}
                                    onKeyUp={(e) => {
                                      if (e.detail.key === "Enter") {
                                        if (isValidPhone(phone.toString())) {
                                          if (inputPassword.length > 5) {
                                            handleValidatePasword()
                                          }
                                        }
                                      }
                                    }}
                                    type={passWordType as InputProps.Type}
                                    onChange={(e) => {
                                      setInputPassword(e.detail.value);
                                    }}
                                    autoComplete={false}
                                  />
                                </FormField>
                              </SpaceBetween>

                            </Form>
                          </Container>
                        </div>
                      </div>
                    </Box>
                  </Container>
                </Grid>
              </Box>
            }
          />
        </div>
      </div>

      </Form >
    </div>



  );
};

export function saveMasters(masters: any, dataTemp: any) {
  if (masters && dataTemp) {
    if (masters.checks) { dataTemp.checks = masters.checks; }
    if (masters.accountPlans) { dataTemp.accountPlans = masters.accountPlans; }
    if (masters.bookingTypes) { dataTemp.bookingTypes = masters.bookingTypes; }
    if (masters.categories) { dataTemp.categories = masters.categories; }
    if (masters.charges) { dataTemp.charges = masters.charges; }
    if (masters.groupTypes) { dataTemp.groupTypes = masters.groupTypes; }
    if (masters.groups) { dataTemp.groups = masters.groups; }
    if (masters.usersStatuses) { dataTemp.usersStatuses = masters.usersStatuses; }
    if (masters.usersTypes) { dataTemp.usersTypes = masters.usersTypes; }
    if (masters.equipments) { dataTemp.equipments = masters.equipments; }
    if (masters.makes) { dataTemp.makes = masters.makes; }
    if (masters.users) { dataTemp.users = masters.users; }
    if (masters.complaintCategories) { dataTemp.complaintCategories = masters.complaintCategories; }
    if (masters.complaintTypes) { dataTemp.complaintTypes = masters.complaintTypes; }
    if (masters.countries) { dataTemp.countries = masters.countries; }

    localStorage.setItem("data", JSON.stringify(dataTemp))
    setData(dataTemp)
    return dataTemp;
  }
}